export enum Authority {
  Admin = 'admin',
  Staff = 'staff',
  Teacher = 'teacher',
  Student = 'student',
  Substitute = 'teacher_substitute'
}
